/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Account_CompanyInputs */

const cs_social_export_account_company = /** @type {(inputs: Social_Export_Account_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firemní účet`)
};

const en_social_export_account_company = /** @type {(inputs: Social_Export_Account_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company account`)
};

/**
* | output |
* | --- |
* | "Company account" |
*
* @param {Social_Export_Account_CompanyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_account_company = /** @type {((inputs?: Social_Export_Account_CompanyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Account_CompanyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_account_company(inputs)
	return cs_social_export_account_company(inputs)
});